import { useState } from "react";
import { useQuery } from "@tanstack/react-query";

import { auditApi } from "@/api/admin";

const ACTION_FILTERS = [
  "",
  "login_success",
  "login_failed",
  "logout",
  "user_created",
  "user_disabled",
  "user_enabled",
  "group_created",
  "group_deleted",
  "membership_added",
  "membership_removed",
  "role_granted",
  "role_revoked",
];

export function AuditPage() {
  const [action, setAction] = useState<string>("");
  const { data, isLoading } = useQuery({
    queryKey: ["admin", "audit", action],
    queryFn: () => auditApi.list(action || undefined),
  });

  return (
    <div>
      <header className="mb-6 flex items-baseline justify-between">
        <div>
          <h1 className="font-display text-2xl text-wm-white">Audit</h1>
          <p className="mt-1 text-sm text-wm-gray-100/60">
            Append-only log of privilege-changing actions.
          </p>
        </div>
        <select
          value={action}
          onChange={(e) => setAction(e.target.value)}
          className="rounded-md border border-white/10 bg-transparent px-2 py-1 text-sm text-wm-white"
        >
          {ACTION_FILTERS.map((a) => (
            <option key={a} value={a}>
              {a === "" ? "all actions" : a}
            </option>
          ))}
        </select>
      </header>

      {isLoading ? (
        <p className="text-sm text-wm-gray-100/60">Loading…</p>
      ) : (
        <table className="w-full text-left text-sm">
          <thead className="text-xs uppercase tracking-wider text-wm-gray-100/60">
            <tr>
              <th className="py-2 pr-4">When</th>
              <th className="py-2 pr-4">Action</th>
              <th className="py-2 pr-4">Actor</th>
              <th className="py-2 pr-4">Target</th>
              <th className="py-2">Meta</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-white/5">
            {data?.rows.map((row) => (
              <tr key={row.id}>
                <td className="py-2 pr-4 font-mono text-xs text-wm-gray-100/70">
                  {new Date(row.created_at).toLocaleString()}
                </td>
                <td className="py-2 pr-4 text-wm-white">{row.action}</td>
                <td className="py-2 pr-4 text-wm-gray-100/80">
                  {row.actor_user_id ?? "—"}
                </td>
                <td className="py-2 pr-4 text-wm-gray-100/80">
                  {row.target_type
                    ? `${row.target_type}:${row.target_id ?? "?"}`
                    : "—"}
                </td>
                <td className="py-2 font-mono text-[11px] text-wm-gray-100/60">
                  {Object.keys(row.meta).length
                    ? JSON.stringify(row.meta)
                    : "—"}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
